// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.divider[data-v-40f01099] {\n  width: 100%;\n  height: 1px;\n  background-color: var(--semantic-color-neutral-subtle, #F2F1F3);\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
